import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import DataConnector from 'connect/DataConnector';
import ProteinActions from 'molbio/aa-sequences/AaSequenceActions';
import ProteinStore from 'molbio/aa-sequences/AaSequenceStore';
import AminoAcidProperties from 'molbio/aa-sequences/AminoAcidProperties';
import Spinner from 'ui-library/Spinner';

class ProteinComplexPreviewConnector extends DataConnector<Props, EnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [ProteinStore];

  enhanceProps(): EnhancedProps {
    const aminoAcids = [];
    for (const proteinId of this.props.proteinIds) {
      const protein = this.proteinStore().getProteinById(proteinId);
      if (!protein) {
        return {
          isLoading: true,
        };
      }
      aminoAcids.push(protein.version.aminoAcids);
    }
    return {
      isLoading: false,
      combinedAminoAcids: aminoAcids.join(''),
    };
  }
}

interface Props {
  proteinIds: Array<string>;
}

type EnhancedProps = {isLoading: true} | {isLoading: false; combinedAminoAcids: string};

class ProteinComplexPreview extends React.Component<Props & EnhancedProps> {
  override componentDidMount(): void {
    this.props.proteinIds.forEach((proteinId) => {
      ProteinActions.open(proteinId, {});
    });
  }

  override render(): JSX.Element {
    if (this.props.isLoading) {
      return (
        <div className="text-center u-spacing-top">
          <div>Loading...</div>
          <Spinner />
        </div>
      );
    }
    return (
      <div className={css(styles.wrapper)}>
        <AminoAcidProperties aminoAcids={this.props.combinedAminoAcids} />
      </div>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default ProteinComplexPreviewConnector.connect(ProteinComplexPreview);
